import common from './resources/common/common.id';

export default { common };
